const Global = {
  language: "fa",
};

export default Global;
